import React from 'react';
import './purchasedItemDetails.scss';
import { useSelector } from 'react-redux';

const PurchasedItemDetails = (props) => {
    const countrySetting = useSelector(state => state.countrySetting);

    return (
        <div className="content_item_shopping">
            <div className="row align-items-center">
                <div className="col-lg-3">
                    <span className="bg_logo_shop">
                        <img src={props.logo} alt="" />
                    </span>
                </div>
                <div className="col-lg-9">
                    <p className="item_purchased box_flex">
                        <span>({props.quantity})</span>
                        <span>{props.description}</span>
                        <span>{countrySetting.currency}{(Number(props.subTotal)).toLocaleString(countrySetting.cultureCode, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PurchasedItemDetails;